import React, { useEffect, useMemo, useState } from "react";
import arrowExitGray from '../assets/images/arrow-modal-exit-gray.png';
import loadingIcon from "../assets/images/loading.gif";
import { ICompletedCourse } from "../models/get-course.model.";
import { IGroupData } from "../models/Group";
import { getCompletedCourseList } from "../services/api/course.service";
import { PdfGeneratorService } from "../services/pdf-generator.service";
import { SendCourseCertificate } from "../services/sendEmail";
import { CompletedCourseCard } from "./cards/completedCourseCard";

interface ModalProps {
  onClose: () => void;
  group: IGroupData;
}

export const ModalCourses = ({ onClose, group }: ModalProps) => {

  const [courseList, setCourseList] = useState<ICompletedCourse[]>([]);

  const [pageCourse, setPageCourse] = useState<number>(1);


  const [screenSize, setScreenSize] = useState<{ width: number, height: number }>({ width: window.innerWidth, height: window.innerHeight })
  const [modalSize, setModalSize] = useState<string>('1')

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getCourses = () => {
    getCompletedCourseList(group.id).then((result) => {
      if (result) {
        setCourseList(result.data);
      }
    });
  };

  const getCalcScale = () => {
    const width = screenSize.width;
    const height = screenSize.height;

    const defaultSize = '1';

    const fractionWidth = width / 650;
    const fractionHeight = (height - 100) / 300;

    const isWidthLonger = (650 * fractionHeight) >= (width - 100);


    if (width <= 600 && width < height) {
      setModalSize(defaultSize);
      return;
    }

    if (isWidthLonger) {
      setModalSize(fractionWidth.toString())
      return
    }

    if (fractionHeight < 1) {
      const waitSize = (300 * 0.9)
      const currentSize = height - 60
      const isLonger = waitSize >= currentSize
      if (isLonger) {
        const difference = waitSize - currentSize
        const heightDifference = (waitSize) - difference;
        const fractionFixed = 0.9 * heightDifference / waitSize;

        setModalSize(fractionFixed.toString())
        return
      }
    } else {
      const calculatedSize = ((height - 100) * 0.9) / 300;
      setModalSize(calculatedSize.toString())
      return
    }
  }

  const handleSelectCourse = async (course: ICompletedCourse) => {
    setIsLoading(true);
    localStorage.setItem("asg_course", JSON.stringify(course))
    const service = PdfGeneratorService();
    service.generateCertificate(course);
    await SendCourseCertificate();
    setIsLoading(false);
    localStorage.removeItem("asg_course")
  }

  const handleNextPage = () => setPageCourse(pageCourse + 1);
  const handleBackPage = () => setPageCourse(pageCourse - 1);

  const isPortraitAndMiniumSize = () => {
    return screenSize.width <= 600 && screenSize.width < screenSize.height;
  }

  const currentCourseList = useMemo(() => {
    const currentList = courseList

    const startIndex = (pageCourse - 1) * 6;
    const endIndex = startIndex + 6;

    return currentList.slice(startIndex, endIndex)
  }, [courseList, pageCourse])


  useEffect(() => {
    const handleResize = () => {
      setScreenSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  useEffect(() => {
    getCalcScale()
  }, [screenSize]);


  useEffect(() => {
    getCalcScale()
    getCourses();
  }, []);

  return (
    <>
      {
        isLoading && (
          <div className="loading_all_page">
            <img src={loadingIcon} alt="loading" width="120" height="120" />
          </div>
        )
      }
      <div className="modal modal-groups">
        <div className={`modal-body modal-courses-body ${isPortraitAndMiniumSize() ? 'ordered' : ''}`}
          style={{ scale: modalSize }}
        >
          <div className="title-body">
            Certificados listos
          </div>
          <div className="gap-4 grid-items">
            {currentCourseList.map((course) => (
              <CompletedCourseCard course={course} onSelect={() => handleSelectCourse(course)} />
            ))}
          </div>
          <div className="close" onClick={() => pageCourse * 6 >= courseList.length ? onClose() : handleNextPage()}>
            <img src={arrowExitGray} alt="exite-arrow" />
          </div>
          {
            pageCourse > 1 && (
              <div className="back" onClick={handleBackPage}>
                <img src={arrowExitGray} alt="exite-arrow" />
              </div>
            )
          }
        </div>
      </div>
    </>
  );
};
